import { render } from "./ManageFriendsView.vue?vue&type=template&id=d06c353c&ts=true"
import script from "./ManageFriendsView.vue?vue&type=script&lang=ts"
export * from "./ManageFriendsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__